(() => {
  if (window.__AMV_PRODUCT_FINAL_V2__) return;
  window.__AMV_PRODUCT_FINAL_V2__ = true;

  const roots = document.querySelectorAll('[data-amv-product]');
  if (!roots.length) return;

  const handleize = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' en ')
    .replace(/kleur\s*:/g, '')
    .replace(/color\s*:/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const tokenList = (value) => {
    const raw = String(value || '').trim();
    const out = new Set();
    const full = handleize(raw);
    if (full) out.add(full);

    raw
      .replace(/[\[\](){}]/g, ' ')
      .split(/\s*(?:\/|,|\||\+|&|\ben\b|\band\b)\s*/i)
      .forEach((part) => {
        const token = handleize(part);
        if (token) out.add(token);
      });

    return Array.from(out).filter(Boolean);
  };

  const colorsMatch = (mediaColor, selectedColor) => {
    const mediaTokens = tokenList(mediaColor);
    const selectedTokens = tokenList(selectedColor);
    if (!mediaTokens.length || !selectedTokens.length) return false;
    return mediaTokens.some((mediaToken) => selectedTokens.includes(mediaToken) || mediaToken.includes(selectedTokens[0]) || selectedTokens[0].includes(mediaToken));
  };

  const textMentionsColor = (text, selectedColor) => {
    const textHandle = handleize(text);
    const colorHandle = handleize(selectedColor);
    if (!textHandle || !colorHandle) return false;
    return textHandle === colorHandle || textHandle.includes(colorHandle) || colorHandle.includes(textHandle);
  };

  const mediaMatchesColor = (el, selectedColor) => {
    if (!el || !String(selectedColor || '').trim()) return false;
    const token = el.dataset.amvMediaColor || '';
    const alt = el.dataset.amvMediaAlt || el.querySelector('img')?.alt || '';
    return colorsMatch(token, selectedColor) || textMentionsColor(alt, selectedColor);
  };

  const getVariantMediaId = (variant) => {
    if (!variant) return null;
    return (
      variant.featured_media?.id ||
      variant.featured_image?.id ||
      variant.featured_image_id ||
      variant.image_id ||
      null
    );
  };

  const getVariantImageUrl = (variant) => {
    if (!variant) return '';
    return (
      variant.featured_image?.src ||
      variant.featured_image?.url ||
      variant.image?.src ||
      variant.image?.url ||
      ''
    );
  };

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0) / 100;
    const amount = value.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (!format) return `€ ${amount}`;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount\s*\}\}/g, value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString());
  };

  const rootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const updateCartCount = (cart) => {
    if (!cart || typeof cart.item_count === 'undefined') return;

    document.querySelectorAll('[data-amarelle-cart-count], [data-cart-count], .cart-count-bubble span:first-child, #cart-icon-bubble .cart-count-bubble span:first-child').forEach((el) => {
      el.textContent = String(cart.item_count || 0);
      el.classList.toggle('is-zero', Number(cart.item_count) === 0);
      if (Number(cart.item_count) === 0) el.setAttribute('aria-hidden', 'true');
      else el.removeAttribute('aria-hidden');
    });
  };

  const fetchCart = async () => {
    const response = await fetch(`${rootUrl()}cart.js?_=${Date.now()}`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    return response.json();
  };

  const renderDrawerFromCart = (cart) => {
    updateCartCount(cart);

    if (window.AmarelleCartDrawer && typeof window.AmarelleCartDrawer.renderCart === 'function') {
      window.AmarelleCartDrawer.renderCart(cart, { open: true });
      return;
    }

    document.dispatchEvent(new CustomEvent('amarelle:cart:render', {
      bubbles: true,
      detail: { cart, open: true, source: 'amv-product' }
    }));

    const drawer = document.querySelector('[data-amarelle-cart-drawer]');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('amarelle-cart-open');
      document.body.classList.add('amarelle-cart-open');
    }
  };

  roots.forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-amv-variants]')?.textContent || '[]');
    const form = root.querySelector('[data-amv-product-form]');
    const variantIdInput = root.querySelector('[data-amv-variant-id]') || form?.querySelector('input[name="id"]');
    const atcButton = root.querySelector('[data-amv-add-to-cart]');
    const buyBox = root.querySelector('[data-amv-buy-box]');
    const priceCurrent = root.querySelector('[data-amv-current-price]');
    const priceCompare = root.querySelector('[data-amv-compare-price]');
    const discount = root.querySelector('[data-amv-discount]');
    const stock = root.querySelector('[data-amv-stock]');
    const stockText = root.querySelector('[data-amv-stock-text]');
    const payment = root.querySelector('[data-amv-payment]');
    const mobileAtc = document.querySelector('[data-amv-mobile-atc]');
    const mobileSubmit = document.querySelector('[data-amv-mobile-submit]');
    const mobilePrice = document.querySelector('[data-amv-mobile-price]');
    const moneyFormat = root.dataset.moneyFormat || '';
    const atcText = root.dataset.atcText || 'Toevoegen aan winkelwagen';
    const soldoutText = root.dataset.soldoutText || 'Uitverkocht';
    const unavailableText = root.dataset.unavailableText || 'Niet beschikbaar';

    if (!form || !variantIdInput) return;

    const optionInputs = Array.from(root.querySelectorAll('[data-amv-option-input]'));
    const optionGroups = Array.from(root.querySelectorAll('[data-amv-option-group]'));
    const colorGroup = optionGroups.find(g => g.dataset.isColor === 'true');

    const selectedOptions = () => {
      const selected = [];
      optionGroups.forEach((group) => {
        const checked = group.querySelector('[data-amv-option-input]:checked');
        selected[Number(group.dataset.optionPosition || 1) - 1] = checked ? checked.value : '';
      });
      return selected;
    };

    const findVariant = (selected) => variants.find(v => v.options.every((opt, index) => String(opt) === String(selected[index])));

    const getCurrentVariant = () => {
      const variant = findVariant(selectedOptions());
      if (variant) return variant;
      const fromInput = variants.find(v => String(v.id) === String(variantIdInput.value));
      return fromInput || variants.find(v => v.available) || variants[0] || null;
    };

    const getColorValue = () => colorGroup ? (colorGroup.querySelector('[data-amv-option-input]:checked')?.value || '') : '';

    const setActiveLabels = () => {
      optionGroups.forEach(group => {
        const checked = group.querySelector('[data-amv-option-input]:checked');
        const valueText = group.querySelector('[data-amv-option-value]');
        if (valueText && checked) valueText.textContent = checked.value;
        group.querySelectorAll('[data-amv-option-label]').forEach(label => {
          label.classList.toggle('is-selected', checked && label.dataset.optionValue === checked.value);
        });
      });
    };

    const updateAvailabilityForOptions = () => {
      const current = selectedOptions();
      optionInputs.forEach(input => {
        const pos = Number(input.dataset.optionPosition || 1) - 1;
        const candidate = current.slice();
        candidate[pos] = input.value;
        const existsAny = variants.some(v => v.options.every((opt, idx) => String(opt) === String(candidate[idx])));
        const existsAvailable = variants.some(v => v.available && v.options.every((opt, idx) => String(opt) === String(candidate[idx])));
        const unavailable = !existsAny || !existsAvailable;
        const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        input.disabled = unavailable && !input.checked;
        if (label) label.classList.toggle('is-unavailable', unavailable && !input.checked);
      });
    };

    const visibleGalleryItems = (selector) => Array.from(root.querySelectorAll(selector)).filter(el => !el.hidden);

    const setActiveMedia = (target) => {
      if (!target) return false;
      root.querySelectorAll('[data-amv-media]').forEach(s => s.classList.toggle('is-active', s === target));
      root.querySelectorAll('[data-amv-thumb]').forEach(t => t.classList.toggle('is-active', t.dataset.amvThumbIndex === target.dataset.amvSlideIndex));
      target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      const activeThumb = root.querySelector(`[data-amv-thumb-index="${CSS.escape(target.dataset.amvSlideIndex || '')}"]`);
      activeThumb?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      return true;
    };

    const scrollToMedia = (mediaId) => {
      const target = root.querySelector(`[data-amv-media-id="${CSS.escape(String(mediaId))}"]`);
      if (!target || target.hidden) return false;
      return setActiveMedia(target);
    };

    const filterGalleryByColor = (selectedColorValue, variant) => {
      const slides = Array.from(root.querySelectorAll('[data-amv-media]'));
      const thumbs = Array.from(root.querySelectorAll('[data-amv-thumb]'));
      if (!slides.length) return;

      const hasSelectedColor = !!String(selectedColorValue || '').trim();
      const matchingSlides = hasSelectedColor ? slides.filter(slide => mediaMatchesColor(slide, selectedColorValue)) : [];
      const useFilter = hasSelectedColor && matchingSlides.length > 0;

      slides.forEach(slide => {
        slide.hidden = useFilter ? !mediaMatchesColor(slide, selectedColorValue) : false;
      });

      thumbs.forEach(thumb => {
        thumb.hidden = useFilter ? !mediaMatchesColor(thumb, selectedColorValue) : false;
      });

      let activeSet = false;
      const variantMediaId = getVariantMediaId(variant);
      if (variantMediaId) activeSet = scrollToMedia(variantMediaId);
      if (!activeSet && useFilter) activeSet = setActiveMedia(matchingSlides[0]);
      if (!activeSet) {
        const currentActive = root.querySelector('[data-amv-media].is-active:not([hidden])');
        activeSet = currentActive ? setActiveMedia(currentActive) : false;
      }
      if (!activeSet) {
        const firstVisible = visibleGalleryItems('[data-amv-media]')[0];
        if (firstVisible) setActiveMedia(firstVisible);
      }
    };

    const updatePrice = (variant) => {
      if (!variant) return;

      const price = formatMoney(variant.price, moneyFormat);

      if (priceCurrent) priceCurrent.textContent = price;
      if (mobilePrice) mobilePrice.textContent = price;

      const hasDiscount =
        variant.compare_at_price &&
        Number(variant.compare_at_price) > Number(variant.price);

      if (hasDiscount) {
        if (priceCompare) {
          priceCompare.hidden = false;
          priceCompare.removeAttribute('aria-hidden');
          priceCompare.style.removeProperty('display');
          priceCompare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        }

        if (discount) {
          const pct = Math.round(((Number(variant.compare_at_price) - Number(variant.price)) * 100) / Number(variant.compare_at_price));

          discount.hidden = false;
          discount.removeAttribute('aria-hidden');
          discount.style.removeProperty('display');
          discount.textContent = `${pct}% OFF`;
        }
      } else {
        if (priceCompare) {
          priceCompare.hidden = true;
          priceCompare.setAttribute('aria-hidden', 'true');
          priceCompare.style.setProperty('display', 'none', 'important');
          priceCompare.textContent = '';
        }

        if (discount) {
          discount.hidden = true;
          discount.setAttribute('aria-hidden', 'true');
          discount.style.setProperty('display', 'none', 'important');
          discount.textContent = '';
        }
      }
    };

    const updatePurchaseState = (variant) => {
      const available = !!(variant && variant.available);
      if (variantIdInput && variant) {
        variantIdInput.value = String(variant.id);
        variantIdInput.setAttribute('value', String(variant.id));
      }
      if (atcButton) {
        atcButton.disabled = !available;
        atcButton.textContent = variant ? (available ? atcText : soldoutText) : unavailableText;
      }
      if (buyBox) buyBox.toggleAttribute('data-soldout', !available);
      if (payment) payment.hidden = !available;
      if (mobileAtc) mobileAtc.hidden = !available;
      if (stock) {
        stock.toggleAttribute('data-soldout', !available);
        if (stockText) stockText.textContent = variant ? (available ? (stockText.dataset.defaultText || 'Nog maar enkele stuks over') : soldoutText) : unavailableText;
      }
    };

    const updateUrl = (variant) => {
      if (!variant || !window.history || !root.dataset.productUrl) return;
      const url = new URL(window.location.href);
      url.pathname = root.dataset.productUrl;
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    const hydrateDynamicSwatches = () => {
      if (!colorGroup) return;
      const colorLabels = Array.from(colorGroup.querySelectorAll('[data-amv-option-label]'));
      if (!colorLabels.length) return;

      colorLabels.forEach((label) => {
        const swatch = label.querySelector('span');
        if (!swatch) return;

        const optionValue = label.dataset.optionValue || '';
        const matchingThumb = Array.from(root.querySelectorAll('[data-amv-thumb]')).find((thumb) => {
          return colorsMatch(thumb.dataset.amvMediaColor || thumb.dataset.amvMediaAlt || '', optionValue);
        });
        const img = matchingThumb ? matchingThumb.querySelector('img') : null;

        if (img && (img.currentSrc || img.src)) {
          swatch.style.setProperty('background-image', `url("${img.currentSrc || img.src}")`);
          swatch.style.setProperty('background-size', 'cover');
          swatch.style.setProperty('background-position', 'center');
          swatch.style.setProperty('background-color', '#F5F1EC');
          label.classList.add('has-image-swatch');
        } else {
          swatch.style.removeProperty('background-image');
          swatch.style.removeProperty('background-size');
          swatch.style.removeProperty('background-position');
          label.classList.remove('has-image-swatch');
        }
      });
    };

    const sync = () => {
      const variant = getCurrentVariant();
      setActiveLabels();
      updateAvailabilityForOptions();
      if (variant) updatePrice(variant);
      updatePurchaseState(variant);
      updateUrl(variant);
      filterGalleryByColor(getColorValue(), variant);
      return variant;
    };

    const getActiveImageUrl = (variant) => {
      const activeImg = root.querySelector('[data-amv-media].is-active:not([hidden]) img');
      if (activeImg && (activeImg.currentSrc || activeImg.src)) return activeImg.currentSrc || activeImg.src;

      const activeThumb = root.querySelector('[data-amv-thumb].is-active:not([hidden]) img');
      if (activeThumb && (activeThumb.currentSrc || activeThumb.src)) return activeThumb.currentSrc || activeThumb.src;

      const color = getColorValue();
      const matchingThumb = Array.from(root.querySelectorAll('[data-amv-thumb]')).find((thumb) => mediaMatchesColor(thumb, color));
      const matchingImg = matchingThumb?.querySelector('img');
      if (matchingImg && (matchingImg.currentSrc || matchingImg.src)) return matchingImg.currentSrc || matchingImg.src;

      return getVariantImageUrl(variant);
    };

    const setButtonLoading = (loading) => {
      if (!atcButton) return;

      if (loading) {
        atcButton.dataset.originalText = atcButton.textContent.trim();
        atcButton.disabled = true;
        atcButton.textContent = 'Toevoegen...';
      } else {
        atcButton.disabled = false;
        atcButton.textContent = atcButton.dataset.originalText || atcText;
      }
    };

    const waitForCartToContainVariant = async (variantId, previousItemCount) => {
      let lastCart = null;

      for (let i = 0; i < 14; i += 1) {
        try {
          const cart = await fetchCart();
          lastCart = cart;
          updateCartCount(cart);

          const hasVariant = Array.isArray(cart.items) && cart.items.some(item => String(item.variant_id) === String(variantId));
          const countMoved = Number(cart.item_count || 0) > Number(previousItemCount || 0);

          if (hasVariant && countMoved) return cart;
          if (hasVariant && i > 2) return cart;
        } catch (e) {}

        await sleep(120);
      }

      return lastCart || fetchCart();
    };

    const addToCartAjax = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (form.dataset.amvAdding === 'true') return;

      const variant = sync();
      if (!variant || !variant.id) {
        alert('Variant kon niet worden gevonden.');
        return;
      }

      if (variant.available === false) {
        alert('Deze variant is uitverkocht.');
        return;
      }

      variantIdInput.value = String(variant.id);
      variantIdInput.setAttribute('value', String(variant.id));

      form.dataset.amvAdding = 'true';
      setButtonLoading(true);

      try {
        const beforeCart = await fetchCart().catch(() => null);
        const previousItemCount = beforeCart ? Number(beforeCart.item_count || 0) : 0;

        const formData = new FormData(form);
        formData.set('id', String(variant.id));
        if (!formData.get('quantity')) formData.set('quantity', '1');

        const selectedColor = getColorValue();
        const imageUrl = getActiveImageUrl(variant);

        if (selectedColor) {
          formData.set('properties[_amarelle_color]', selectedColor);
        }
        if (imageUrl) {
          formData.set('properties[_amarelle_image]', imageUrl);
        }

        const addResponse = await fetch(`${rootUrl()}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const addedItem = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) {
          throw new Error(addedItem.description || addedItem.message || 'Niet toegevoegd');
        }

        const cart = await waitForCartToContainVariant(variant.id, previousItemCount);
        renderDrawerFromCart(cart);

        if (atcButton) {
          atcButton.textContent = 'Toegevoegd';
          setTimeout(() => {
            if (!form.dataset.amvAdding && !atcButton.disabled) atcButton.textContent = atcText;
          }, 900);
        }
      } catch (error) {
        console.error('Amarelle add to cart error:', error);
        if (atcButton) {
          atcButton.textContent = error.message || 'Niet toegevoegd';
          setTimeout(() => { atcButton.textContent = atcText; }, 1600);
        }
      } finally {
        delete form.dataset.amvAdding;
        setButtonLoading(false);
      }
    };

    optionInputs.forEach(input => input.addEventListener('change', sync));

    root.querySelectorAll('[data-amv-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.amvThumbId;
        if (mediaId) scrollToMedia(mediaId);
      });
    });

    const viewport = root.querySelector('[data-amv-gallery-viewport]');
    if (viewport) {
      let t;
      viewport.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const slides = visibleGalleryItems('[data-amv-media]');
          if (!slides.length) return;
          const rect = viewport.getBoundingClientRect();
          const center = rect.left + rect.width / 2;
          let best = slides[0];
          let bestDist = Infinity;
          slides.forEach(slide => {
            const r = slide.getBoundingClientRect();
            const dist = Math.abs((r.left + r.width / 2) - center);
            if (dist < bestDist) {
              bestDist = dist;
              best = slide;
            }
          });
          setActiveMedia(best);
        }, 80);
      }, { passive: true });
    }

    const visibleSlides = () => visibleGalleryItems('[data-amv-media]');
    const moveGallery = (direction) => {
      const slides = visibleSlides();
      if (!slides.length) return;
      const current = root.querySelector('[data-amv-media].is-active:not([hidden])') || slides[0];
      const currentIndex = Math.max(0, slides.indexOf(current));
      const nextIndex = (currentIndex + direction + slides.length) % slides.length;
      setActiveMedia(slides[nextIndex]);
    };

    root.querySelector('[data-amv-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
    root.querySelector('[data-amv-gallery-next]')?.addEventListener('click', () => moveGallery(1));

    const swipeTarget = root.querySelector('[data-amv-gallery-main]') || viewport;
    if (swipeTarget) {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      swipeTarget.addEventListener('touchstart', (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
      }, { passive: true });

      swipeTarget.addEventListener('touchend', (event) => {
        if (!tracking) return;
        const touch = event.changedTouches && event.changedTouches[0];
        tracking = false;
        if (!touch) return;

        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        if (Math.abs(dx) < 38 || Math.abs(dx) < Math.abs(dy) * 1.15) return;

        if (dx < 0) moveGallery(1);
        else moveGallery(-1);
      }, { passive: true });
    }

    root.querySelector('[data-amv-qty-minus]')?.addEventListener('click', () => {
      const qty = root.querySelector('input[name="quantity"]');
      if (!qty) return;
      qty.value = Math.max(1, Number(qty.value || 1) - 1);
    });

    root.querySelector('[data-amv-qty-plus]')?.addEventListener('click', () => {
      const qty = root.querySelector('input[name="quantity"]');
      if (!qty) return;
      qty.value = Number(qty.value || 1) + 1;
    });

    form.addEventListener('submit', addToCartAjax, true);

    mobileSubmit?.addEventListener('click', (event) => {
      event.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    hydrateDynamicSwatches();
    const defaultStock = stockText ? stockText.textContent : '';
    if (stockText) stockText.dataset.defaultText = defaultStock;
    sync();
  });

  document.addEventListener('submit', function (event) {
    const form = event.target?.closest?.('[data-amv-product-form]');
    if (!form || form.dataset.amvCaptureHandled === 'true') return;

    const productRoot = form.closest('[data-amv-product]');
    if (!productRoot) return;

    event.preventDefault();
  }, true);

  const recentSection = document.querySelector('[data-amv-recently-viewed]');
  if (recentSection) {
    const key = 'amv_recently_viewed_products';
    const current = {
      id: recentSection.dataset.currentId,
      title: recentSection.dataset.currentTitle,
      url: recentSection.dataset.currentUrl,
      price: recentSection.dataset.currentPrice,
      image: recentSection.dataset.currentImage
    };
    let items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { items = []; }
    const shown = items.filter(item => item && item.id && String(item.id) !== String(current.id)).slice(0, 4);
    const grid = recentSection.querySelector('[data-amv-recent-grid]');
    if (grid && shown.length) {
      shown.forEach(item => {
        const card = document.createElement('a');
        card.className = 'amv-card';
        card.href = item.url || '#';
        card.setAttribute('aria-label', item.title || 'Product');

        const media = document.createElement('span');
        media.className = 'amv-card__media';
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.loading = 'lazy';
          media.appendChild(img);
        }

        const body = document.createElement('span');
        body.className = 'amv-card__body';
        const title = document.createElement('span');
        title.className = 'amv-card__title';
        title.textContent = item.title || '';
        const price = document.createElement('span');
        price.className = 'amv-card__price';
        const strong = document.createElement('strong');
        strong.textContent = item.price || '';
        price.appendChild(strong);
        body.append(title, price);
        card.append(media, body);
        grid.appendChild(card);
      });
      recentSection.hidden = false;
    }
    if (current.id && current.title && current.url) {
      const next = [current].concat(items.filter(item => String(item.id) !== String(current.id))).slice(0, 8);
      try { localStorage.setItem(key, JSON.stringify(next)); } catch (e) {}
    }
  }
})();